<button
  class="stdCareProposalWrapper"
  [ngClass]="{
    'stdCareProposalWrapper--selected': selected
  }"
  (click)="this.tileClicked.emit()"
>
  {{ name }}
  <div class="stdCareProposalWithArticles" *ngIf="withArticle">
    <itl-alberta-icon name="alberta-article"></itl-alberta-icon> Artikel vorbelegt
  </div>
</button>
